import { updateDoc } from 'firebase/firestore/lite';
import { localconfigs } from './apiConfig';
import { serviceId } from './fire-conf';
export const postDocument = async (payload, token) => {
  let walletId = '00000000-0000-0000-0000-000000000000';
  return await new Promise((resolve, reject) => {
    var myHeaders = new Headers();
    myHeaders.append('accept', '*/*');
    myHeaders.append('walletID', walletId);
    myHeaders.append('authToken', token);
    myHeaders.append('serviceID', serviceId);
    myHeaders.append('Content-Type', 'application/json');

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({ dataArray: payload }),
      redirect: 'follow',
    };
    fetch('https://api.relysia.com/v1/redeem', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log('befour then');
        if (result.statusCode == 200) {
          resolve(result);
        } else {
          reject(result);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
